/**
 * プリセットの見本の絵（#216）。GET /paper/presets の thumbs（見本のデータで本物の流し込み型の紙を描いた PNG）を小さく出す。
 * 設定 → 帳票デザイン（プリセットの行）と、紙の画面の「書式」の横。PC だけ（スマホ版では出さない＝styles.css の html[data-view="phone"]）。
 * 縦の紙は 34×48・横の紙は 48×34 を 48×48 の枠の真ん中に（並べたとき名前の頭がそろう）
 */
export function PaperThumb({ src, orient, name }: { src: string | undefined; orient: "portrait" | "landscape"; name: string }) {
  if (!src) return null;
  const land = orient === "landscape";
  return (
    <span className="pthumb" aria-hidden="true">
      <img src={src} alt="" width={land ? 48 : 34} height={land ? 34 : 48} loading="lazy" decoding="async" title={`${name}の見本`} />
    </span>
  );
}
